import React from 'react';
import SolutionPageLayout from '../../components/SolutionPageLayout';
import BfsiImage from '../../assets/generated-pages/bfsi-ai-solutions.png';

export default function BfsiSystem() {
  return (
    <SolutionPageLayout
      eyebrow="BFSI System"
      title="AI-Powered BFSI Solutions"
      subtitle="Secure, intelligent transformation for banking, financial services, and insurance."
      description="Vedalytics helps BFSI teams modernize operations with AI-led fraud intelligence, automated service journeys, risk analytics, and secure digital workflows designed for faster decisions and better customer experiences."
      image={BfsiImage}
      stats={[
        { value: '24/7', label: 'customer support automation' },
        { value: 'AI', label: 'fraud and anomaly detection' },
        { value: 'Secure', label: 'data-first financial workflows' },
        { value: 'Faster', label: 'risk and decision cycles' },
      ]}
      highlights={[
        { icon: 'trust', title: 'Fraud Prevention', text: 'Analyze transaction patterns and behavioral signals to detect suspicious activity earlier and protect financial operations.' },
        { icon: 'ai', title: 'Automated Customer Support', text: 'Deploy smart assistants and guided workflows that improve response time while reducing repetitive service load.' },
        { icon: 'analytics', title: 'Risk Intelligence', text: 'Convert financial data into actionable risk insights for lending, insurance, investment, and compliance teams.' },
      ]}
      overviewTitle="Revolutionizing BFSI with AI and automation"
      overviewText="Our BFSI solutions connect automation, analytics, and secure AI capabilities across customer operations, risk teams, and back-office processes. The goal is simple: stronger trust, smarter decisions, and more efficient financial service delivery."
      overviewPoints={[
        'Real-time fraud signals and transaction monitoring.',
        'AI-assisted service journeys for banking and insurance customers.',
        'Risk scoring, compliance support, and portfolio intelligence.',
        'Integration-ready workflows for modern and legacy systems.',
      ]}
      workflowTitle="From data signals to secure decisions"
      workflow={[
        { title: 'Map Workflows', text: 'Identify high-value BFSI processes, risk points, data sources, and compliance requirements.' },
        { title: 'Build Intelligence', text: 'Design AI models and automation flows for fraud, service, claims, or risk operations.' },
        { title: 'Integrate Safely', text: 'Connect AI outputs with existing platforms while keeping governance and security in view.' },
        { title: 'Optimize Continuously', text: 'Measure impact, tune models, and improve decisions with operational feedback.' },
      ]}
      outcomesTitle="What BFSI teams gain"
      outcomes={[
        'Enhanced security and fraud prevention.',
        'Reduced manual processing and operational cost.',
        'More personalized customer experiences.',
        'Better data-driven risk and compliance decisions.',
      ]}
    />
  );
}
